export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-[#1E4433] text-white">
      <div className="max-w-6xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-10 flex items-center justify-center bg-[#C8A97E] rounded-full flex-shrink-0">
                <span className="text-white font-bold text-base" style={{ fontFamily: 'Playfair Display, serif' }}>H</span>
              </div>
              <div>
                <p className="font-bold text-base uppercase tracking-widest" style={{ fontFamily: 'Playfair Display, serif' }}>HORN</p>
                <p className="text-white/60 text-[10px] uppercase tracking-widest">Property Maintenance &amp; Construction</p>
              </div>
            </div>
            <p className="text-white/65 text-sm leading-relaxed mb-6 max-w-xs" style={{ fontFamily: 'Inter, sans-serif' }}>
              Burlington's trusted property maintenance and construction team. Building trust with quality work since day one.
            </p>
            <div className="flex gap-3">
              <a
                href="https://www.facebook.com/hornpmc"
                rel="nofollow"
                target="_blank"
                aria-label="Horn PMC on Facebook"
                className="w-8 h-8 flex items-center justify-center bg-white/10 rounded-md hover:bg-[#C8A97E] transition-colors"
              >
                <i className="ri-facebook-fill text-sm"></i>
              </a>
              <a
                href="https://www.instagram.com/hornpmc"
                rel="nofollow"
                target="_blank"
                aria-label="Horn PMC on Instagram"
                className="w-8 h-8 flex items-center justify-center bg-white/10 rounded-md hover:bg-[#C8A97E] transition-colors"
              >
                <i className="ri-instagram-line text-sm"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold text-xs uppercase tracking-[0.2em] mb-5">
              <a href="#quick-links">Quick Links</a>
            </h4>
            <ul className="space-y-3">
              {[
                { label: 'Home', href: '/' },
                { label: 'Services', href: '#services' },
                { label: 'Projects', href: '#projects' },
                { label: 'About Us', href: '#about-us' },
                { label: 'Get a Quote', href: '#contact' },
              ].map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-white/65 text-sm hover:text-[#C8A97E] transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold text-xs uppercase tracking-[0.2em] mb-5">
              <a href="#contact">Contact</a>
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-2.5">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-phone-fill text-[#C8A97E] text-sm"></i>
                </div>
                <a href="tel:9058694676" className="text-white/65 text-sm hover:text-[#C8A97E] transition-colors">
                  905-869-4676
                </a>
              </li>
              <li className="flex items-start gap-2.5">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-map-pin-fill text-[#C8A97E] text-sm"></i>
                </div>
                <p className="text-white/65 text-sm">Burlington, Oakville &amp; Hamilton, Ontario</p>
              </li>
              <li className="flex items-start gap-2.5">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-time-fill text-[#C8A97E] text-sm"></i>
                </div>
                <p className="text-white/65 text-sm">Mon–Fri: 8:00 AM – 5:00 PM</p>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="max-w-6xl mx-auto px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/45 text-xs" style={{ fontFamily: 'Inter, sans-serif' }}>
            &copy; {year} Horn Property Maintenance and Construction. All rights reserved.
          </p>
          <p className="text-white/45 text-xs">
            Burlington, Ontario, Canada
          </p>
        </div>
      </div>
    </footer>
  );
}
